module.exports = __webpack_public_path__ + "static/webinars-fa61f4c5f70835285d4c870f024721f2.jpg";